import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";
import { Store } from "@ngxs/store";
import { AuthActions, CurrentAccountSelectors } from "@ha/feature/auth";
import { UserActivateActions } from "../user-activate/states/user-activate.actions";
import { UserStateActions } from "../user/state/user.actions";
import { validatePnr } from "@ha/util/common";

@Component({
    templateUrl: "./personal-number.component.html",
    styleUrls: ["./personal-number.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalNumberComponent extends BaseModalComponent implements OnInit {

    public personalNumber = '';

    public hasForeignPersonalNumber = false;

    public isPersonalNumberValid = true;

    constructor(private store: Store, private cdr : ChangeDetectorRef) {
        super();
    }

    public get isValid() {
        return (this.personalNumber != "" || this.hasForeignPersonalNumber == true);
    }

    public ngOnInit(): void {
        this.store.dispatch(new UserActivateActions.GetActivationAgreement());
    }

    public hasForeginPersonalNumberClick() : void {
        this.personalNumber = '';
        this.isPersonalNumberValid = true;
    }

    public personalNumberOnChange() : void {
        this.hasForeignPersonalNumber = false;
    }

    public cancel(): void {
        this.store.dispatch(new AuthActions.SignOut());
    }

    public accept(): void {
        if(this.personalNumber !== '') {
            this.isPersonalNumberValid = validatePnr(this.personalNumber)
        }

        if(this.isPersonalNumberValid)
        {
            let currentAccount = this.store.selectSnapshot(CurrentAccountSelectors.currentAccount);
            this.store.dispatch(new UserStateActions.SetPersonalNumber
            (
                {
                    identityUserId: currentAccount.identityUserId,
                    personalNumber: this.personalNumber,
                    hasForeignPersonalNumber: this.hasForeignPersonalNumber
                }
            ));
            this.closeModal();
        }
    }
}
